import React from "react";

import { IsPad, IsDesktop } from "../../../../components/ResponsiveContainers";
import ProductImageSlider from "../../../../components/Sliders/ProductImageSlider";
import ProductImageSliderCommon from "../../../../components/Sliders/ProductImageSliderCommon";
import { Container } from "./styled";

const ClosetsSlider = () => {
  const imageData = [
    {
      id: 1,
      mainImgUrl: "/images/home_page/closets.png",
      smallImgUrl: "/images/home_page/closets.png",
    },
    {
      id: 2,
      mainImgUrl: "/images/home_page/homeoffice.png",
      smallImgUrl: "/images/home_page/homeoffice.png",
    },
    {
      id: 3,
      mainImgUrl: "/images/home_page/laundryroom.png",
      smallImgUrl: "/images/home_page/laundryroom.png",
    },
    {
      id: 4,
      mainImgUrl: "/images/home_page/pantries.png",
      smallImgUrl: "/images/home_page/pantries.png",
    },
  ];

  return (
    <Container>
      <IsDesktop>
        <ProductImageSlider sliderData={imageData} />
      </IsDesktop>
      <IsPad>
        <ProductImageSliderCommon sliderData={imageData} />
      </IsPad>
      
    </Container>
  );
};

export default ClosetsSlider;
